import { sendGAEvent } from '@noths/polaris-client-google-analytics';

import type { TrackingContext } from 'src/types/TrackingContext';

export interface VideoTracking extends TrackingContext {
  videoTitle: string;
}

export const trackYouTubeVideoImpression = ({
  trackingPosition,
  trackingTitle,
  videoTitle,
}: VideoTracking) => {
  sendGAEvent({
    event: 'custom_event',
    event_action: 'Impression',
    event_category: `${trackingPosition} | Video block`,
    event_label: `${trackingPosition} | ${trackingTitle} | ${videoTitle}`.toLowerCase(),
    event_name: 'view_content',
    content_position: `${trackingPosition}`,
    content_type: `video block|${trackingTitle}`.toLowerCase(),
    video_title: `${videoTitle}`.toLowerCase(),
  });
};

export const trackYouTubeVideoClick = ({
  trackingPosition,
  trackingTitle,
  videoTitle,
}: VideoTracking) => {
  sendGAEvent({
    event: 'custom_event',
    event_action: 'Video click',
    event_category: `${trackingPosition} | Video block`,
    event_label: `${trackingPosition} | ${trackingTitle} | ${videoTitle}`.toLowerCase(),
    event_name: 'content_interaction',
    event_details: 'video click',
    content_position: `${trackingPosition}`,
    content_type: `video block|${trackingTitle}`.toLowerCase(),
    video_title: `${videoTitle}`.toLowerCase(),
  });
};
